import React, { useState } from "react";
import CustomInput from "../../../common/CustomInput";
import Button from "../../../common/Button";
import {
  countryOptions,
  designationOptions,
  physicianOptions,
  stateOptions,
} from "../../create/options";
import {
  isFieldError,
  isValidPhoneNumber,
  isFieldWithLengthError,
} from "../../../../helpers/input-validations";
import CommonSlider from "../../../common/CommonSlider";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { extractPhoneNumber } from "../../../../helpers/functions";
import { useDispatch } from "react-redux";
import {
  createCareproviderDetails,
  updateCareproviderDetails,
} from "../../../../redux/modules/patient/actions";
import ConfirmationModalNew from "../../../common/ConfirmationModalNew";

const PhysicianCreate = ({
  open,
  onClose,
  physician,
  patient,
  create = false,
}) => {
  const dispatch = useDispatch();

  const [openPrimaryPhysician, setOpenPrimaryPhysician] = useState(false);
  const [careProviders, setCareProviders] = useState([
    {
      firstNameCareProvider: create ? "" : physician.firstName,
      middleNameCareProvider: create ? "" : physician.middleName,
      lastNameCareProvider: create ? "" : physician.lastName,
      licenseNumberCareProvider: create ? "" : physician.licenseNumber,
      designationCareProvider: create ? "" : physician.title,
      phoneCountryCareProvider: create
        ? "+1"
        : physician.primaryPhoneCountryCode,
      phoneNumberCareProvider: create ? "" : physician.primaryPhone,
      faxCareProvider: create ? "" : physician.fax,
      emailCareProvider: create ? "" : physician.email,
      addressCareProvider: create ? "" : physician.address,
      unitCareProvider: create ? "" : physician.unitNumber,
      poBoxCareProvider: create ? "" : physician.poBox,
      cityCareProvider: create ? "" : physician.city,
      stateCareProvider: create ? "" : physician.province,
      postalCodeCareProvider: create ? "" : physician.postalCode,
      countryCareProvider: create ? "" : physician.country,
      commentsCareProvider: create ? "" : physician.comments,
      contactOptionsCareProvider: create
        ? "primary"
        : physician.primaryProvider
        ? "primary"
        : "",
      errors: {
        firstNameCareProvider: "",
        lastNameCareProvider: "",
        licenseNumberCareProvider: "",
        designationCareProvider: "",
        phoneNumberCareProvider: "",
        faxCareProvider: "",
      },
    },
  ]);

  const handleInputChange = (index, key, value) => {
    const updatedCareProviders = [...careProviders];
    updatedCareProviders[index][key] = value;

    const {
      firstNameCareProvider,
      lastNameCareProvider,
      licenseNumberCareProvider,
      designationCareProvider,
      faxCareProvider,
      phoneNumberCareProvider,
    } = updatedCareProviders[index];

    // Perform validation and set error messages
    const errors = {
      firstNameCareProvider:
        updatedCareProviders[index].errors.firstNameCareProvider || false,
      lastNameCareProvider:
        updatedCareProviders[index].errors.lastNameCareProvider || false,
      licenseNumberCareProvider:
        updatedCareProviders[index].errors.licenseNumberCareProvider || false,
      designationCareProvider:
        updatedCareProviders[index].errors.designationCareProvider || false,
      // faxCareProvider:
      //   updatedCareProviders[index].errors.faxCareProvider || false,
      // phoneNumberCareProvider:
      //   updatedCareProviders[index].errors.phoneNumberCareProvider || false,
    };

    if (key === "lastNameCareProvider") {
      errors.lastNameCareProvider = isFieldError(lastNameCareProvider);
    } else if (key === "firstNameCareProvider") {
      errors.firstNameCareProvider = isFieldError(firstNameCareProvider);
    } else if (key === "licenseNumberCareProvider") {
      errors.licenseNumberCareProvider = isFieldWithLengthError(
        licenseNumberCareProvider,
        5
      );
    } else if (key === "designationCareProvider") {
      errors.designationCareProvider = isFieldError(designationCareProvider);
    } 
    // else if (key === "phoneNumberCareProvider") {
    //   errors.phoneNumberCareProvider = !isValidPhoneNumber(
    //     phoneNumberCareProvider
    //   );
    // } else if (key === "faxCareProvider") {
    //   errors.faxCareProvider = isFieldError(faxCareProvider);
    // }

    // Set error state
    updatedCareProviders[index].errors = errors;

    // Update the isCompleted flag
    updatedCareProviders[index].isCompleted =
      firstNameCareProvider &&
      !errors.firstNameCareProvider &&
      lastNameCareProvider &&
      !errors.lastNameCareProvider &&
      licenseNumberCareProvider &&
      !errors.licenseNumberCareProvider &&
      designationCareProvider &&
      !errors.designationCareProvider 
      // && faxCareProvider &&
      // !errors.faxCareProvider &&
      // phoneNumberCareProvider &&
      // !errors.phoneNumberCareProvider;

    setCareProviders(updatedCareProviders);
  };

  const primaryPhysicianVerification = () => {
    const provider = careProviders[0];
    if (
      !create &&
      !physician.primaryProvider &&
      provider.contactOptionsCareProvider === "primary"
    )
      setOpenPrimaryPhysician(true);
    else manageStep();
  };

  const manageStep = () => {
    // Initialize a flag to check if there are any errors
    let hasErrors = false;

    // Loop through each care provider to check for errors
    const updatedCareProviders = careProviders.map((provider, index) => {
      const {
        firstNameCareProvider,
        lastNameCareProvider,
        licenseNumberCareProvider,
        designationCareProvider,
        // faxCareProvider,
        // phoneNumberCareProvider,
      } = provider;

      // Create an object to track errors for the current provider
      const errors = {
        firstNameCareProvider: isFieldError(firstNameCareProvider),
        lastNameCareProvider: isFieldError(lastNameCareProvider),
        licenseNumberCareProvider: isFieldError(licenseNumberCareProvider),
        designationCareProvider: isFieldError(designationCareProvider),
        // faxCareProvider: isFieldError(faxCareProvider),
        // phoneNumberCareProvider: !isValidPhoneNumber(phoneNumberCareProvider),
      };

      // Check if any error exists for this provider
      const hasProviderErrors = Object.values(errors).some((error) => error);

      // Update the error state for this provider
      provider.errors = errors;

      // Update the isCompleted flag for this provider
      provider.isCompleted =
        firstNameCareProvider &&
        lastNameCareProvider &&
        licenseNumberCareProvider &&
        designationCareProvider &&
        // faxCareProvider &&
        // phoneNumberCareProvider &&
        !hasProviderErrors;

      // If any errors were found for this provider, set the flag to true
      if (hasProviderErrors) {
        hasErrors = true;
      }

      return provider;
    });

    // Update the state with the updated care providers data
    setCareProviders(updatedCareProviders);
    // Check if there are any errors in the entire form
    if (!hasErrors) {
      const provider = careProviders[0];
      const careProvider = {
        firstName: provider.firstNameCareProvider,
        middleName: provider.middleNameCareProvider,
        lastName: provider.lastNameCareProvider,
        title: provider.designationCareProvider,
        licenseNumber: provider.licenseNumberCareProvider,
        notes: provider.commentsCareProvider || null,
        primaryProvider:
          provider.contactOptionsCareProvider === "primary" ? true : false, // Set to true or false as needed
        contactInfo: {
          primaryPhoneCountryCode: provider.phoneCountryCareProvider || null,
          primaryPhone:
            extractPhoneNumber(provider.phoneNumberCareProvider) || null,
          email: provider.emailCareProvider || null,
          address: provider.addressCareProvider || null,
          city: provider.cityCareProvider || null,
          province: provider.stateCareProvider || null,
          fax: provider.faxCareProvider || null,
          postalCode:
            provider.postalCodeCareProvider?.replace(/\s/g, "") || null,
          primaryContact: true, // Set to true or false as needed
          country: provider.countryCareProvider || null,
          poBox: provider.poBoxCareProvider || null,
        },
      };

      if (create) {
        dispatch(createCareproviderDetails(patient.id, careProvider));
      } else {
        dispatch(updateCareproviderDetails(physician.id, careProvider));
      }
      onClose(false);
    }
  };

  return (
    <CommonSlider open={open} onClose={onClose}>
      <div className="flex flex-col flex-1 h-full overflow-y-auto ">
        <div className="relative flex flex-col flex-1">
          {/* Header */}
          <div className="px-8 py-6 bg-gray-20">
            <div className="flex items-start justify-between space-x-3">
              <div className="flex flex-col">
                <p className="font-bold text-gray-800 text-display-xs">
                  {create ? "Add " : "Edit "} Primary Provider Information
                </p>
                <p className="text-body-md text-gray-700">
                  {patient.lastName}, {patient.firstName}
                </p>
              </div>
              <div className="flex items-center">
                <button
                  type="button"
                  className="flex items-center justify-center p-1 transition-all rounded-full max-w-8 cursor-pointer right-4 top-3 bg-blue-200 hover:bg-REELTeal hover:text-white text-teal-300"
                  onClick={() => onClose(false)}
                >
                  <span className="sr-only">Close panel</span>
                  <XMarkIcon
                    className="w-5 h-5 m-auto" 
                    strokeWidth="2"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-between flex-1 px-8 mt-4">
            <div className="grid grid-cols-12 gap-3">
              <CustomInput
                name={`lastNameCareProvider_${0}`}
                className="col-span-4"
                label="Last Name"
                placeholder="Enter last name"
                type="text"
                value={careProviders[0].lastNameCareProvider}
                capitalizeFirstLetter={true}
                onChange={(e) =>
                  handleInputChange(0, "lastNameCareProvider", e.target.value)
                }
                error={careProviders[0].errors.lastNameCareProvider}
                required
              />
              <CustomInput
                name={`middleNameCareProvider_${0}`}
                className="col-span-4"
                label="Middle Name"
                placeholder="Enter middle name"
                type="text"
                value={careProviders[0].middleNameCareProvider}
                capitalizeFirstLetter={true}
                onChange={(e) =>
                  handleInputChange(0, "middleNameCareProvider", e.target.value)
                }
              />
              <CustomInput
                name={`firstNameCareProvider_${0}`}
                className="col-span-4"
                label="First Name"
                placeholder="Enter first name"
                type="text"
                value={careProviders[0].firstNameCareProvider}
                capitalizeFirstLetter={true}
                onChange={(e) =>
                  handleInputChange(0, "firstNameCareProvider", e.target.value)
                }
                error={careProviders[0].errors.firstNameCareProvider}
                required
              />
              <CustomInput
                name={`licenseNumberCareProvider_${0}`}
                className="col-span-6"
                label="License Number"
                placeholder="XXXXX"
                type="text"
                value={careProviders[0].licenseNumberCareProvider}
                onChange={(e) =>
                  handleInputChange(
                    0,
                    "licenseNumberCareProvider",
                    e.target.value
                  )
                }
                error={careProviders[0].errors.licenseNumberCareProvider}
                required
              />
              <CustomInput
                options={designationOptions}
                name={`designationCareProvider_${0}`}
                className="col-span-6"
                label="Designation"
                type="dropdown"
                value={careProviders[0].designationCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "designationCareProvider", e.value)
                }
                error={careProviders[0].errors.designationCareProvider}
                required
              />
              <p className="pl-2 pb-3 col-span-12 text-gray-700 text-body-xs">
                <span>
                  Search license number{" "}
                  <u>
                    <a target="_blank" href="https://www.cpso.on.ca">
                      here
                    </a>
                  </u>
                  .
                </span>
              </p>
              <CustomInput
                className="col-span-12"
                options={physicianOptions}
                type="radio"
                name={`contactOptionsCareProvider_${0}`}
                value={careProviders[0].contactOptionsCareProvider}
                onChange={(e) =>
                  handleInputChange(
                    0,
                    "contactOptionsCareProvider",
                    e.target.value
                  )
                }
              />
              <div className="col-span-12 my-3 bg-gray-100 h-[1px] w-full " />
              <p className="col-span-12 font-medium text-gray-900 text-body-md">
                Contact Information
              </p>
              <CustomInput
                name={`phoneNumberCareProvider_${0}`}
                className="col-span-6"
                label="Phone Number"
                placeholder="(555) 000-0000"
                type="phone"
                handleSelect={(e) =>
                  handleInputChange(
                    0,
                    "phoneCountryCareProvider",
                    e.target.value
                  )
                }
                selectValue={careProviders[0].phoneCountryCareProvider}
                error={careProviders[0].errors.phoneNumberCareProvider}
                value={careProviders[0].phoneNumberCareProvider}
                onChange={(e) =>
                  handleInputChange(
                    0,
                    "phoneNumberCareProvider",
                    e.target.value
                  )
                }
                // required - TODO: https://app.clickup.com/t/86dtjjy8z revisit in Aug-Oct
              />
              <CustomInput
                name={`faxCareProvider_${0}`}
                className="col-span-6"
                label="FAX"
                placeholder="Enter Fax"
                type="text"
                mask="(999) 999-9999"
                value={careProviders[0].faxCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "faxCareProvider", e.target.value)
                }
                error={careProviders[0].errors.faxCareProvider}
                // required - TODO: https://app.clickup.com/t/86dtjjy8z revisit in Aug-Oct
              />
              <CustomInput
                name={`emailCareProvider_${0}`}
                className="col-span-12"
                label="Email Address"
                placeholder="Enter Email Address"
                type="email"
                value={careProviders[0].emailCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "emailCareProvider", e.target.value)
                }
              />
              <CustomInput
                name={`addressCareProvider_${0}`}
                className="col-span-12"
                label="Address"
                placeholder=" Enter Street Number & Street Name"
                type="text"
                value={careProviders[0].addressCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "addressCareProvider", e.target.value)
                }
              />
              <CustomInput
                name={`unitCareProvider_${0}`}
                className="col-span-6"
                label="Unit Number"
                placeholder="Enter Unit Number"
                type="text"
                value={careProviders[0].unitCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "unitCareProvider", e.target.value)
                }
              />
              <CustomInput
                name={`poBoxCareProvider_${0}`}
                className="col-span-6"
                label="PO Box"
                placeholder="PO Box"
                type="age"
                value={careProviders[0].poBoxCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "poBoxCareProvider", e.target.value)
                }
              />
              <CustomInput
                name={`cityCareProvider_${0}`}
                className="col-span-6"
                label="City"
                placeholder="Enter City"
                type="text"
                value={careProviders[0].cityCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "cityCareProvider", e.target.value)
                }
              />
              <CustomInput
                options={stateOptions}
                name={`stateCareProvider_${0}`}
                className="col-span-6"
                label="Province/State"
                type="dropdown"
                value={careProviders[0].stateCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "stateCareProvider", e.value)
                }
              />
              <CustomInput
                name={`postalCodeCareProvider_${0}`}
                className="col-span-6"
                label="Postal Code"
                placeholder="Enter Postal Code"
                type="postalCode"
                value={careProviders[0].postalCodeCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "postalCodeCareProvider", e.target.value)
                }
              />
              <CustomInput
                options={countryOptions}
                name={`countryCareProvider_${0}`}
                className="col-span-6"
                label="Country"
                type="dropdown"
                value={careProviders[0].countryCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "countryCareProvider", e.value)
                }
              />
              <div className="col-span-12 my-3 bg-gray-100 h-[1px] w-full " />
              <CustomInput
                name={`commentsCareProvider_${0}`}
                className="col-span-12"
                label="Comments"
                placeholder="Enter Note"
                type="text"
                value={careProviders[0].commentsCareProvider}
                onChange={(e) =>
                  handleInputChange(0, "commentsCareProvider", e.target.value)
                }
              />
            </div>
            <div className="flex items-center justify-center py-6">
              <div className="flex items-center justify-center space-x-5">
                <Button
                  className="min-w-[200px]"
                  text={`Cancel`}
                  type="secondary"
                  onClick={() => onClose(false)}
                />
                <Button
                  className="min-w-[200px]"
                  text={`${create ? "Save" : "Update"}`}
                  type="primary"
                  onClick={() => {
                    primaryPhysicianVerification();
                  }}
                />
              </div>
              {/* confirmation while making non-Primary Provider a primary.*/}
              <ConfirmationModalNew
                type="primary"
                title="Primary Provider"
                content={() => (
                  <>
                    Are you sure you want to save{" "}
                    <b>
                      {physician?.lastName +
                        " " +
                        physician?.middleName +
                        " " +
                        physician?.firstName}
                    </b>{" "}
                    as your Primary Provider?
                  </>
                )}
                confirmAction={() => {
                  setOpenPrimaryPhysician(false);
                  manageStep();
                }}
                handleClose={() => setOpenPrimaryPhysician(false)}
                onCross={() => setOpenPrimaryPhysician(false)}
                open={openPrimaryPhysician}
                confirmText="Yes, Continue"
              />
            </div>
          </div>
        </div>
      </div>
    </CommonSlider>
  );
};

export default PhysicianCreate;
